<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <!-- Header -->
    <app-account-header></app-account-header>

    @if (isSocialLogin) {
      <div class="alert alert-warning" role="alert">
        <p>Vous êtes connectés avec un compte Social. Certains champs ne peuvent être modifiés. Pour les modifier,
        veuillez le faire dans les paramètres de votre compte Google ou Microsoft.</p>
        <!--            <p><a href="#">Pour modifier les informations de votre compte Google.</a></p>-->
      </div>
    }
    <!--        <div class="alert alert-warning" role="alert" *ngIf="isSocialLoginMicrosoft">-->
    <!--            <p>Vous êtes connectés avec un compte Microsoft. Certains champs ne peuvent être modifiés. Pour les modifier, veuillez le faire dans les paramètres de votre compte Microsoft.</p>-->

    <!--            <p><a href="#">Pour modifier les informations de votre compte Microsoft.</a></p>-->
  <!--        </div>-->

  <app-alert-messages></app-alert-messages>

  <h3 class="mt-2 h5">Email</h3>
  <p class="text-secondary">{{ user.email }}</p>

  <!-- Form -->
  <form [formGroup]="form">

    <div class="row">
      <div class="col-12 col-md-6">
        <!-- First name -->
        <magieno-input-text-field [advancedFormControl]="firstName"></magieno-input-text-field>
      </div>
      <div class="col-12 col-md-6">
        <!-- Last name -->
        <magieno-input-text-field [advancedFormControl]="lastName"></magieno-input-text-field>
      </div>
    </div> <!-- / .row -->

    <!--            todo for now we only support fr-->
    <!--            <div class="row">-->
    <!--                <div class="col-12 col-md-6">-->
    <!--                    <app-select [advancedFormControl]="language"></app-select>-->
  <!--                </div>-->
<!--            </div> &lt;!&ndash; / .row &ndash;&gt;-->

<!-- Button -->
<div class="row">
  <div class="col-12">
    <magieno-button [button]="form.getButton('SAVE')" class="mt-4"></magieno-button>
  </div>
</div>

</form>

<br><br>

</div>
</div> <!-- / .row -->
